import { render } from "./HighchartGraph.vue?vue&type=template&id=45b9726d"
import script from "./HighchartGraph.vue?vue&type=script&lang=js"
export * from "./HighchartGraph.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__